export const digidaigakuNFTs = [
  
  {
    id: 'digidaigaku-genesis-1909',
    name: 'DigiDaigaku Genesis #1909',
    image: 'https://digidaigaku.com/image/1909.png',
    price: '3.15 ETH'
  },
  {
    id: 'digidaigaku-genesis-712',
    name: 'DigiDaigaku Genesis #712',
    image: 'https://digidaigaku.com/image/712.png',
    price: '2.88 ETH'
  },
  {
    id: 'digidaigaku-genesis-710',
    name: 'DigiDaigaku Genesis #710',
    image: 'https://digidaigaku.com/image/710.png',
    price: '3.42 ETH'
  },
  {
    id: 'digidaigaku-genesis-709',
    name: 'DigiDaigaku Genesis #709',
    image: 'https://digidaigaku.com/image/709.png',
    price: '2.75 ETH'
  },
  {
    id: 'digidaigaku-genesis-711',
    name: 'DigiDaigaku Genesis #711',
    image: 'https://digidaigaku.com/image/711.png',
    price: '3.65 ETH'
  },
  {
    id: 'digidaigaku-genesis-708',
    name: 'DigiDaigaku Genesis #708',
    image: 'https://digidaigaku.com/image/708.png',
    price: '2.94 ETH'
  },
  {
    id: 'digidaigaku-genesis-706',
    name: 'DigiDaigaku Genesis #706',
    image: 'https://digidaigaku.com/image/706.png',
    price: '3.28 ETH'
  },
  {
    id: 'digidaigaku-genesis-2014',
    name: 'DigiDaigaku Genesis #2014',
    image: 'https://digidaigaku.com/image/2014.png',
    price: '2.69 ETH'
  },
  {
    id: 'digidaigaku-genesis-1971',
    name: 'DigiDaigaku Genesis #1971',
    image: 'https://digidaigaku.com/image/1971.png',
    price: '3.55 ETH'
  },
  {
    id: 'digidaigaku-genesis-2020',
    name: 'DigiDaigaku Genesis #2020',
    image: 'https://digidaigaku.com/image/2020.png',
    price: '2.82 ETH'
  },
  {
    id: 'digidaigaku-genesis-2002',
    name: 'DigiDaigaku Genesis #2002',
    image: 'https://digidaigaku.com/image/2002.png',
    price: '3.35 ETH'
  },
  {
    id: 'digidaigaku-genesis-2018',
    name: 'DigiDaigaku Genesis #2018',
    image: 'https://digidaigaku.com/image/2018.png',
    price: '2.98 ETH'
  },
  {
    id: 'digidaigaku-genesis-2010',
    name: 'DigiDaigaku Genesis #2010',
    image: 'https://digidaigaku.com/image/2010.png',
    price: '3.48 ETH'
  },
  {
    id: 'digidaigaku-genesis-1995',
    name: 'DigiDaigaku Genesis #1995',
    image: 'https://digidaigaku.com/image/1995.png',
    price: '2.73 ETH'
  },
  {
    id: 'digidaigaku-genesis-2016',
    name: 'DigiDaigaku Genesis #2016',
    image: 'https://digidaigaku.com/image/2016.png',
    price: '3.62 ETH'
  },
  {
    id: 'digidaigaku-genesis-2012',
    name: 'DigiDaigaku Genesis #2012',
    image: 'https://digidaigaku.com/image/2012.png',
    price: '2.91 ETH'
  },
  {
    id: 'digidaigaku-genesis-2022',
    name: 'DigiDaigaku Genesis #2022',
    image: 'https://digidaigaku.com/image/2022.png',
    price: '3.25 ETH'
  },
  {
    id: 'digidaigaku-genesis-2021',
    name: 'DigiDaigaku Genesis #2021',
    image: 'https://digidaigaku.com/image/2021.png',
    price: '2.85 ETH'
  },
  {
    id: 'digidaigaku-genesis-2015',
    name: 'DigiDaigaku Genesis #2015',
    image: 'https://digidaigaku.com/image/2015.png',
    price: '3.58 ETH'
  },
  {
    id: 'digidaigaku-genesis-2019',
    name: 'DigiDaigaku Genesis #2019',
    image: 'https://digidaigaku.com/image/2019.png',
    price: '2.79 ETH'
  },
  {
    id: 'digidaigaku-genesis-2009',
    name: 'DigiDaigaku Genesis #2009',
    image: 'https://digidaigaku.com/image/2009.png',
    price: '3.45 ETH'
  },
  {
    id: 'digidaigaku-genesis-2006',
    name: 'DigiDaigaku Genesis #2006',
    image: 'https://digidaigaku.com/image/2006.png',
    price: '2.95 ETH'
  },
  {
    id: 'digidaigaku-genesis-2017',
    name: 'DigiDaigaku Genesis #2017',
    image: 'https://digidaigaku.com/image/2017.png',
    price: '3.32 ETH'
  },
  {
    id: 'digidaigaku-genesis-2013',
    name: 'DigiDaigaku Genesis #2013',
    image: 'https://digidaigaku.com/image/2013.png',
    price: '2.71 ETH'
  },
  {
    id: 'digidaigaku-genesis-2011',
    name: 'DigiDaigaku Genesis #2011',
    image: 'https://digidaigaku.com/image/2011.png',
    price: '3.68 ETH'
  },
  {
    id: 'digidaigaku-genesis-2007',
    name: 'DigiDaigaku Genesis #2007',
    image: 'https://digidaigaku.com/image/2007.png',
    price: '2.89 ETH'
  },
  {
    id: 'digidaigaku-genesis-1985',
    name: 'DigiDaigaku Genesis #1985',
    image: 'https://digidaigaku.com/image/1985.png',
    price: '3.22 ETH'
  },
  {
    id: 'digidaigaku-genesis-1994',
    name: 'DigiDaigaku Genesis #1994',
    image: 'https://digidaigaku.com/image/1994.png',
    price: '2.83 ETH'
  },
  {
    id: 'digidaigaku-genesis-2001',
    name: 'DigiDaigaku Genesis #2001',
    image: 'https://digidaigaku.com/image/2001.png',
    price: '3.52 ETH'
  },
  {
    id: 'digidaigaku-genesis-1978',
    name: 'DigiDaigaku Genesis #1978',
    image: 'https://digidaigaku.com/image/1978.png',
    price: '2.77 ETH'
  },
  {
    id: 'digidaigaku-genesis-1998',
    name: 'DigiDaigaku Genesis #1998',
    image: 'https://digidaigaku.com/image/1998.png',
    price: '3.38 ETH'
  },
  {
    id: 'digidaigaku-genesis-1984',
    name: 'DigiDaigaku Genesis #1984',
    image: 'https://digidaigaku.com/image/1984.png',
    price: '2.92 ETH'
  },
  {
    id: 'digidaigaku-genesis-2003',
    name: 'DigiDaigaku Genesis #2003',
    image: 'https://digidaigaku.com/image/2003.png',
    price: '3.18 ETH'
  },
  {
    id: 'digidaigaku-genesis-1992',
    name: 'DigiDaigaku Genesis #1992',
    image: 'https://digidaigaku.com/image/1992.png',
    price: '2.87 ETH'
  },
  {
    id: 'digidaigaku-genesis-2000',
    name: 'DigiDaigaku Genesis #2000',
    image: 'https://digidaigaku.com/image/2000.png',
    price: '3.59 ETH'
  },
  {
    id: 'digidaigaku-genesis-2008',
    name: 'DigiDaigaku Genesis #2008',
    image: 'https://digidaigaku.com/image/2008.png',
    price: '2.81 ETH'
  },
  {
    id: 'digidaigaku-genesis-1965',
    name: 'DigiDaigaku Genesis #1965',
    image: 'https://digidaigaku.com/image/1965.png',
    price: '3.44 ETH'
  },
  {
    id: 'digidaigaku-genesis-1997',
    name: 'DigiDaigaku Genesis #1997',
    image: 'https://digidaigaku.com/image/1997.png',
    price: '2.96 ETH'
  },
  {
    id: 'digidaigaku-genesis-1990',
    name: 'DigiDaigaku Genesis #1990',
    image: 'https://digidaigaku.com/image/1990.png',
    price: '3.29 ETH'
  },
  {
    id: 'digidaigaku-genesis-1999',
    name: 'DigiDaigaku Genesis #1999',
    image: 'https://digidaigaku.com/image/1999.png',
    price: '2.72 ETH'
  },
  {
    id: 'digidaigaku-genesis-2005',
    name: 'DigiDaigaku Genesis #2005',
    image: 'https://digidaigaku.com/image/2005.png',
    price: '3.66 ETH'
  },
  {
    id: 'digidaigaku-genesis-1970',
    name: 'DigiDaigaku Genesis #1970',
    image: 'https://digidaigaku.com/image/1970.png',
    price: '2.90 ETH'
  },
  {
    id: 'digidaigaku-genesis-1979',
    name: 'DigiDaigaku Genesis #1979',
    image: 'https://digidaigaku.com/image/1979.png',
    price: '3.19 ETH'
  },
  {
    id: 'digidaigaku-genesis-1991',
    name: 'DigiDaigaku Genesis #1991',
    image: 'https://digidaigaku.com/image/1991.png',
    price: '2.84 ETH'
  },
  {
    id: 'digidaigaku-genesis-2004',
    name: 'DigiDaigaku Genesis #2004',
    image: 'https://digidaigaku.com/image/2004.png',
    price: '3.49 ETH'
  },
  {
    id: 'digidaigaku-genesis-1987',
    name: 'DigiDaigaku Genesis #1987',
    image: 'https://digidaigaku.com/image/1987.png',
    price: '2.76 ETH'
  },
  {
    id: 'digidaigaku-genesis-1974',
    name: 'DigiDaigaku Genesis #1974',
    image: 'https://digidaigaku.com/image/1974.png',
    price: '3.36 ETH'
  },
  {
    id: 'digidaigaku-genesis-1980',
    name: 'DigiDaigaku Genesis #1980',
    image: 'https://digidaigaku.com/image/1980.png',
    price: '2.93 ETH'
  },
  {
    id: 'digidaigaku-genesis-1989',
    name: 'DigiDaigaku Genesis #1989',
    image: 'https://digidaigaku.com/image/1989.png',
    price: '3.16 ETH'
  },
  {
    id: 'digidaigaku-genesis-1986',
    name: 'DigiDaigaku Genesis #1986',
    image: 'https://digidaigaku.com/image/1986.png',
    price: '2.86 ETH'
  },
  {
    id: 'digidaigaku-genesis-1996',
    name: 'DigiDaigaku Genesis #1996',
    image: 'https://digidaigaku.com/image/1996.png',
    price: '3.56 ETH'
  },
  {
    id: 'digidaigaku-genesis-1993',
    name: 'DigiDaigaku Genesis #1993',
    image: 'https://digidaigaku.com/image/1993.png',
    price: '2.80 ETH'
  },
  {
    id: 'digidaigaku-genesis-1988',
    name: 'DigiDaigaku Genesis #1988',
    image: 'https://digidaigaku.com/image/1988.png',
    price: '3.41 ETH'
  },
  {
    id: 'digidaigaku-genesis-1982',
    name: 'DigiDaigaku Genesis #1982',
    image: 'https://digidaigaku.com/image/1982.png',
    price: '2.97 ETH'
  },
  {
    id: 'digidaigaku-genesis-1969',
    name: 'DigiDaigaku Genesis #1969',
    image: 'https://digidaigaku.com/image/1969.png',
    price: '3.26 ETH'
  },
  {
    id: 'digidaigaku-genesis-1983',
    name: 'DigiDaigaku Genesis #1983',
    image: 'https://digidaigaku.com/image/1983.png',
    price: '2.70 ETH'
  },
  {
    id: 'digidaigaku-genesis-1972',
    name: 'DigiDaigaku Genesis #1972',
    image: 'https://digidaigaku.com/image/1972.png',
    price: '3.12 ETH'
  },
  {
    id: 'digidaigaku-genesis-1981',
    name: 'DigiDaigaku Genesis #1981',
    image: 'https://digidaigaku.com/image/1981.png',
    price: '2.85 ETH'
  },
  {
    id: 'digidaigaku-genesis-1976',
    name: 'DigiDaigaku Genesis #1976',
    image: 'https://digidaigaku.com/image/1976.png',
    price: '3.45 ETH'
  },
  {
    id: 'digidaigaku-genesis-1968',
    name: 'DigiDaigaku Genesis #1968',
    image: 'https://digidaigaku.com/image/1968.png',
    price: '2.73 ETH'
  },
  {
    id: 'digidaigaku-genesis-1973',
    name: 'DigiDaigaku Genesis #1973',
    image: 'https://digidaigaku.com/image/1973.png',
    price: '3.58 ETH'
  },
  {
    id: 'digidaigaku-genesis-1960',
    name: 'DigiDaigaku Genesis #1960',
    image: 'https://digidaigaku.com/image/1960.png',
    price: '2.95 ETH'
  },
  {
    id: 'digidaigaku-genesis-1975',
    name: 'DigiDaigaku Genesis #1975',
    image: 'https://digidaigaku.com/image/1975.png',
    price: '3.28 ETH'
  },
  {
    id: 'digidaigaku-genesis-1962',
    name: 'DigiDaigaku Genesis #1962',
    image: 'https://digidaigaku.com/image/1962.png',
    price: '2.69 ETH'
  },
  {
    id: 'digidaigaku-genesis-1963',
    name: 'DigiDaigaku Genesis #1963',
    image: 'https://digidaigaku.com/image/1963.png',
    price: '3.65 ETH'
  },
  {
    id: 'digidaigaku-genesis-1977',
    name: 'DigiDaigaku Genesis #1977',
    image: 'https://digidaigaku.com/image/1977.png',
    price: '2.88 ETH'
  },
  {
    id: 'digidaigaku-genesis-1959',
    name: 'DigiDaigaku Genesis #1959',
    image: 'https://digidaigaku.com/image/1959.png',
    price: '3.35 ETH'
  },
  {
    id: 'digidaigaku-genesis-1961',
    name: 'DigiDaigaku Genesis #1961',
    image: 'https://digidaigaku.com/image/1961.png',
    price: '2.78 ETH'
  },
  {
    id: 'digidaigaku-genesis-1958',
    name: 'DigiDaigaku Genesis #1958',
    image: 'https://digidaigaku.com/image/1958.png',
    price: '3.52 ETH'
  },
  {
    id: 'digidaigaku-genesis-1966',
    name: 'DigiDaigaku Genesis #1966',
    image: 'https://digidaigaku.com/image/1966.png',
    price: '2.92 ETH'
  },
  {
    id: 'digidaigaku-genesis-1967',
    name: 'DigiDaigaku Genesis #1967',
    image: 'https://digidaigaku.com/image/1967.png',
    price: '3.18 ETH'
  },
  {
    id: 'digidaigaku-genesis-1964',
    name: 'DigiDaigaku Genesis #1964',
    image: 'https://digidaigaku.com/image/1964.png',
    price: '2.82 ETH'
  },
  {
    id: 'digidaigaku-genesis-1957',
    name: 'DigiDaigaku Genesis #1957',
    image: 'https://digidaigaku.com/image/1957.png',
    price: '3.42 ETH'
  },
  {
    id: 'digidaigaku-genesis-1954',
    name: 'DigiDaigaku Genesis #1954',
    image: 'https://digidaigaku.com/image/1954.png',
    price: '2.98 ETH'
  },
  {
    id: 'digidaigaku-genesis-1956',
    name: 'DigiDaigaku Genesis #1956',
    image: 'https://digidaigaku.com/image/1956.png',
    price: '3.25 ETH'
  },
  {
    id: 'digidaigaku-genesis-1955',
    name: 'DigiDaigaku Genesis #1955',
    image: 'https://digidaigaku.com/image/1955.png',
    price: '2.75 ETH'
  },
  {
    id: 'digidaigaku-genesis-1953',
    name: 'DigiDaigaku Genesis #1953',
    image: 'https://digidaigaku.com/image/1953.png',
    price: '3.62 ETH'
  },
  {
    id: 'digidaigaku-genesis-1951',
    name: 'DigiDaigaku Genesis #1951',
    image: 'https://digidaigaku.com/image/1951.png',
    price: '2.89 ETH'
  },
  {
    id: 'digidaigaku-genesis-1952',
    name: 'DigiDaigaku Genesis #1952',
    image: 'https://digidaigaku.com/image/1952.png',
    price: '3.32 ETH'
  },
  {
    id: 'digidaigaku-genesis-1950',
    name: 'DigiDaigaku Genesis #1950',
    image: 'https://digidaigaku.com/image/1950.png',
    price: '2.72 ETH'
  },
  {
    id: 'digidaigaku-genesis-1949',
    name: 'DigiDaigaku Genesis #1949',
    image: 'https://digidaigaku.com/image/1949.png',
    price: '3.68 ETH'
  },
  {
    id: 'digidaigaku-genesis-1945',
    name: 'DigiDaigaku Genesis #1945',
    image: 'https://digidaigaku.com/image/1945.png',
    price: '2.94 ETH'
  },
  {
    id: 'digidaigaku-genesis-1946',
    name: 'DigiDaigaku Genesis #1946',
    image: 'https://digidaigaku.com/image/1946.png',
    price: '3.15 ETH'
  },
  {
    id: 'digidaigaku-genesis-1948',
    name: 'DigiDaigaku Genesis #1948',
    image: 'https://digidaigaku.com/image/1948.png',
    price: '2.86 ETH'
  },
  {
    id: 'digidaigaku-genesis-1942',
    name: 'DigiDaigaku Genesis #1942',
    image: 'https://digidaigaku.com/image/1942.png',
    price: '3.48 ETH'
  },
  {
    id: 'digidaigaku-genesis-1944',
    name: 'DigiDaigaku Genesis #1944',
    image: 'https://digidaigaku.com/image/1944.png',
    price: '2.96 ETH'
  },
  {
    id: 'digidaigaku-genesis-1943',
    name: 'DigiDaigaku Genesis #1943',
    image: 'https://digidaigaku.com/image/1943.png',
    price: '3.22 ETH'
  },
  {
    id: 'digidaigaku-genesis-1947',
    name: 'DigiDaigaku Genesis #1947',
    image: 'https://digidaigaku.com/image/1947.png',
    price: '2.79 ETH'
  },
  {
    id: 'digidaigaku-genesis-1899',
    name: 'DigiDaigaku Genesis #1899',
    image: 'https://digidaigaku.com/image/1899.png',
    price: '3.55 ETH'
  },
  {
    id: 'digidaigaku-genesis-1938',
    name: 'DigiDaigaku Genesis #1938',
    image: 'https://digidaigaku.com/image/1938.png',
    price: '2.91 ETH'
  },
  {
    id: 'digidaigaku-genesis-1933',
    name: 'DigiDaigaku Genesis #1933',
    image: 'https://digidaigaku.com/image/1933.png',
    price: '3.38 ETH'
  },
  {
    id: 'digidaigaku-genesis-1941',
    name: 'DigiDaigaku Genesis #1941',
    image: 'https://digidaigaku.com/image/1941.png',
    price: '2.76 ETH'
  },
  {
    id: 'digidaigaku-genesis-1920',
    name: 'DigiDaigaku Genesis #1920',
    image: 'https://digidaigaku.com/image/1920.png',
    price: '3.70 ETH'
  },
  {
    id: 'digidaigaku-genesis-1927',
    name: 'DigiDaigaku Genesis #1927',
    image: 'https://digidaigaku.com/image/1927.png',
    price: '2.99 ETH'
  },
  {
    id: 'digidaigaku-genesis-1925',
    name: 'DigiDaigaku Genesis #1925',
    image: 'https://digidaigaku.com/image/1925.png',
    price: '3.08 ETH'
  },
  {
    id: 'digidaigaku-genesis-1940',
    name: 'DigiDaigaku Genesis #1940',
    image: 'https://digidaigaku.com/image/1940.png',
    price: '2.83 ETH'
  },
  {
    id: 'digidaigaku-genesis-1934',
    name: 'DigiDaigaku Genesis #1934',
    image: 'https://digidaigaku.com/image/1934.png',
    price: '3.45 ETH'
  },
  {
    id: 'digidaigaku-genesis-1936',
    name: 'DigiDaigaku Genesis #1936',
    image: 'https://digidaigaku.com/image/1936.png',
    price: '2.93 ETH'
  },
  {
    id: 'digidaigaku-genesis-1935',
    name: 'DigiDaigaku Genesis #1935',
    image: 'https://digidaigaku.com/image/1935.png',
    price: '3.29 ETH'
  },
  {
    id: 'digidaigaku-genesis-1924',
    name: 'DigiDaigaku Genesis #1924',
    image: 'https://digidaigaku.com/image/1924.png',
    price: '2.81 ETH'
  }


];